import { Button } from "components/ui/button"
import { Card } from "components/ui/card"
import { Link, useNavigate, useRouteError } from "react-router"
import { getRelayErrorMessage } from "src/common/utils"

export default function ErrorPage() {
  const error = useRouteError() as any
  const navigate = useNavigate()
  console.error(">> error", error)  

  // Auto-reload on chunk load failures from stale deployments
  if (error?.message?.includes("Failed to fetch dynamically imported module")) {
    window.location.reload();
    return null;
  }

  // Get a user-friendly error message
  const errorDisplay = `${error?.name || "Error"}: ${error?.message || "Unknown error"}`;
  const userFriendlyMessage = getRelayErrorMessage(error) || "An unexpected error occurred";
  
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-4 text-left">
      <Card className="max-w-md p-6 bg-popover text-foreground border-border">
        <div className="flex flex-col space-y-4">
          <h2 className="text-xl font-semibold text-red-400">Server Error</h2>
          <p className="text-muted-foreground break-words whitespace-pre-wrap max-h-32 overflow-y-auto">{userFriendlyMessage}</p>
          <p className="text-xs text-muted-foreground">{errorDisplay}</p>
          <div className="flex flex-row space-x-3 pt-2">
            <Button asChild>
              <Link to="/">Go Back</Link>
            </Button>
            <Button variant="secondary" onClick={() => navigate(0)}>
              Retry
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}
